'use client';

import React from "react";
import AlternateImageDetails from "../../AlternateImageDetails";

const purpose = "/assets/dcc/purpose.png";
const keyBenefits = "/assets/dcc/key-benefits.png";
const aboutSections = [
  {
    title: "Purpose",
    content:
      "Digital Command Center streamlines HR, CRM, Project Management, and ERP functionalities into one platform.",
    image: purpose,
  },
  {
    title: "Key Benefits",
    content: (
      <ul className="space-y-2 my-2 text-color-2">
        <li>• Simplify project, talent, and resource management</li>
        <li>• Enhanced Team Collaboration and Client Satisfaction</li>
        <li>• Accessible for Desktop, Tablet, and Mobile</li>
        <li>
          • Boost profitability with actionable insights and streamlined
          workflows.
        </li>
      </ul>
    ),
    image: keyBenefits,
  },
];

function About() {
  return <AlternateImageDetails sections={aboutSections} />;
}

export default About;
